<template>
  <div>
    <div ref="form">
      <!-- Row Loop -->
      <b-row
        v-for="(regimen, index) in RegimenesAduaneros"
        :id="index"
        :key="index"
        ref="row"
      >
        <!-- Item Name -->
        <b-col cols="10">
          <RegimenAduanero :regimen="regimen" :index="index" />
        </b-col>

        <!-- Remove Button -->
        <b-col v-if="RegimenesAduaneros.length > min" cols="2">
          <b-button
            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
            variant="outline-danger"
            class="mt-0 mt-md-2"
            @click="removeItem(index)"
          >
            <feather-icon icon="XIcon" class="mr-25" />
            <span>Borrar</span>
          </b-button>
        </b-col>
      </b-row>

      <b-button
        v-if="RegimenesAduaneros.length < 10"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="secondary"
        @click="addItem"
      >
        <feather-icon icon="PlusIcon" class="mr-25" />
        <span>Agregar régimen aduanero</span>
      </b-button>
    </div>
  </div>
</template>

<script>
import { BRow, BCol, BButton } from 'bootstrap-vue'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import RegimenAduanero from '@/views/CartaPorte/RegimenAduanero.vue'
import { mapMultiRowFields } from 'vuex-map-fields'
import { mapActions } from 'vuex'

export default {
  components: {
    RegimenAduanero,
    BRow,
    BCol,
    BButton,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  props: {
    min: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      nextRowId: 0,
    }
  },
  computed: {
    ...mapMultiRowFields('CartaPorte', {
      RegimenesAduaneros:
        'objJson.complemento.CartaPorte.RegimenesAduaneros.RegimenAduaneroCCP',
    }),
  },
  mounted() {
    this.initTrHeight()
    this.nextRowId = this.RegimenesAduaneros.length
    if (this.RegimenesAduaneros.length < 1) {
      this.addItem()
    }
  },
  created() {
    window.addEventListener('resize', this.initTrHeight)
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    ...mapActions('CartaPorte', [
      'addRegimenAduanero',
      'deleteRegimenAduanero',
    ]),
    addItem() {
      this.addRegimenAduanero({
        '@RegimenAduanero': '',
      })

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
      })
    },
    removeItem(index) {
      this.deleteRegimenAduanero(index)
      this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}
</style>

<style lang="scss">
@import 'src/@core/scss/vue/libs/vue-select.scss';
</style>
